import styles from "./BSMsCheckedOut.module.css";
import { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { ProspectInfoExpander } from "../../ProspectInfoExpander/ProspectInfoExpander";
import { useTranslation } from "react-i18next";
import { useSessionStorage } from "react-use";
import { useBSMs } from "./useBSMs";
import { Toggle } from "@wwg/ui";

export function BSMsCheckedOut({ contact }) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useSessionStorage(
    "prospect-bsm-checked-out-open",
    false
  );
  const bsms = useBSMs({ contact });

  return (
    <ProspectInfoExpander
      isOpen={isOpen}
      onToggle={setIsOpen}
      title={t("labels.prospectBSMsCheckedOut")}
    >
      {bsms.returnable.length === 0 && (
        <span className={styles.emptyLabel}>
          {t("labels.prospectBSMsCheckedOutEmptyLabel")}
        </span>
      )}

      {bsms.returnable.map((b) => (
        <BSMEntry
          key={b.handoutId}
          handout={b}
          onToggle={() => {
            bsms.returnBSMMutation.mutate(b.handoutId);
          }}
        />
      ))}
    </ProspectInfoExpander>
  );
}

function BSMEntry({ handout, onToggle }) {
  const { t } = useTranslation();
  const [on, setOn] = useState(false);

  return (
    <div className={styles.bsmEntry}>
      <span>{handout.name}</span>
      <div className={styles.bsmToggle}>
        <span>{t("labels.prospectBSMReturned")}</span>
        <Toggle
          isOn={on}
          onChange={({ isOn }) => {
            setOn(isOn);
            onToggle();
          }}
        />
      </div>
    </div>
  );
}

BSMsCheckedOut.propTypes = {};
